import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})
export class UpdateService {
    constructor(public http: HttpClient) { }

    checkAppUpdate() {
        const baseUrl = environment.caluwin_api.base_url;
        const endpoint = "";
        const updateUrl = baseUrl + endpoint;
        const options = {
            headers: {
              'Content-Type': 'application/json'
            },
          };

        return this.http.get(updateUrl,options);
    }
}